<template>
  <div>
    <v-layout wrap pa-5>
      <v-flex xs12>
        <span class="heading">Banned Rescuer List</span>
      </v-flex>
      
      <v-flex xs12 pt-3>
        <!-- Tab Navigation -->
        <v-tabs v-model="activeTab" color="#FF6907">
          <v-tab class="subheading">Internal Bans</v-tab>
          <v-tab class="subheading">External Bans</v-tab>
        </v-tabs>

        <!-- Tab Content -->
        <v-tabs-items v-model="activeTab" class="mt-4">
          <v-tab-item>
            <InternalBans />
          </v-tab-item>
          <v-tab-item>
            <ExternalBans />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import InternalBans from "./components/InternalBans.vue";
import ExternalBans from "./components/ExternalBans.vue";

export default {
  components: {
    InternalBans,
    ExternalBans
  },
  data() {
    return {
      activeTab: 0
    };
  }
};
</script>

<style scoped>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}
.subheading {
  font-family: poppinsregular;
  font-size: 15px;
  font-weight: 500;
}
</style>
